import RecordRow from 'components/RecordRow';
import Spacing from 'components/Spacing';
import { dateofBirthToLabel } from 'further-ui/utils';
import { Fragment } from 'react';
import DownloadTransferButton from './DownloadTransferButton';
import InvestorDetailsCustomTags from './InvestorDetailsCustomTags';

type Props = {
  investorDetail: any;
  showFirmName: boolean;
  canEdit: boolean;
};

const LegalEntityDetails: React.FC<Props> = ({
  investorDetail,
  showFirmName,
  canEdit,
}) => {
  return (
    <Spacing size="sm">
      {showFirmName && (
        <RecordRow label="Firm name">{investorDetail?.firmName}</RecordRow>
      )}

      <RecordRow label="Registered name">
        {investorDetail?.registeredName}
      </RecordRow>

      <RecordRow label="Registration number">
        {investorDetail?.registrationNumber}
      </RecordRow>

      <RecordRow label="Registration date">
        {investorDetail?.registrationDate?.toLabel() ?? '-'}
      </RecordRow>

      <RecordRow label="Registration state">
        {investorDetail?.registrationState}
      </RecordRow>

      <RecordRow label="Email address">
        {investorDetail?.email || '-'}
      </RecordRow>

      <RecordRow label="Key contact first name">
        {investorDetail?.keyContactFirstName || '-'}
      </RecordRow>

      <RecordRow label="Key contact surname">
        {investorDetail?.keyContactSurname || '-'}
      </RecordRow>

      <RecordRow label="Key contact phone number">
        {investorDetail?.keyContactPhoneNumber || '-'}
      </RecordRow>

      <RecordRow label="Date registered">
        {investorDetail?.createdAt?.toLabel() ?? '-'}
      </RecordRow>

      <RecordRow label="Last login">
        {investorDetail?.lastLoginDate?.toLabel() ?? '-'}
      </RecordRow>

      {(investorDetail.address ?? []).map((single, index) => (
        <Fragment key={index}>
          <RecordRow
            label={
              index === 0 ? 'Registered address' : `Previous address ${index}`
            }
          >
            <div>
              <div>{single?.address1}</div>
              <div>{single?.address2}</div>
              <div>{single?.city}</div>
              <div>
                {typeof single?.postcode === 'string'
                  ? single?.postcode.toUpperCase()
                  : single?.postcode}
              </div>
              <div>{single?.country}</div>
            </div>
          </RecordRow>

          {index === 0 && (
            <RecordRow label="Registered address remained the same for the past 3 years?">
              {investorDetail?.address && investorDetail?.address.length === 1
                ? 'Yes'
                : 'No'}
            </RecordRow>
          )}
        </Fragment>
      ))}

      <RecordRow label="External investor ID">
        {investorDetail?.externalInvestorId || '-'}
      </RecordRow>

      <RecordRow label="Vulnerable client">
        {investorDetail?.isVulnerableClient ? 'Yes' : 'No'}
      </RecordRow>

      <RecordRow label="Vulnerability notes" direction="row">
        {investorDetail?.vulnerabilityNotes || '-'}
      </RecordRow>

      <RecordRow label="Deceased" direction="row">
        <span>{investorDetail?.isDeceased ? 'Yes' : 'No'}</span>
        {investorDetail?.isDeceased && (
          <DownloadTransferButton
            investorId={investorDetail._id}
            investorName={investorDetail.registeredName}
            firmId={investorDetail.firmId}
          />
        )}
      </RecordRow>

      {investorDetail?.isDeceased && (
        <RecordRow label="Date of death">
          {investorDetail?.dateOfDeath
            ? dateofBirthToLabel(investorDetail?.dateOfDeath?.toISOString())
            : '-'}
        </RecordRow>
      )}

      <RecordRow label="UK remittance taxpayer (BIR)">
        {investorDetail?.isUkRemittanceTaxpayer ? 'Yes' : 'No'}
      </RecordRow>

      <InvestorDetailsCustomTags
        firmId={investorDetail?.firmId}
        investorId={investorDetail?._id}
        customTags={investorDetail?.customTags}
        canEdit={canEdit}
      />
    </Spacing>
  );
};

export default LegalEntityDetails;
